<!--
  ~ Copyright (C) 2021 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<og-grid
  class="og-grid"
  [data]="tableData"
  [agGridOptions]="gridOptions"
  [customOptions]="{ alignment: 'CENTER' }"
></og-grid>
